export default __webpack_public_path__ + "static/media/quote-slide-1.6c52dac1.png";